<template>
    <b-container fluid class="p-3">
        <b-row class="mb-3">
            <b-col class="d-flex align-items-center">
                <BackToMasters navName="" :goback="$router.back"></BackToMasters>
                <h6 class="mb-0">
                    {{ t("assetManagement.maintenancedetails.heading") }}
                </h6>
            </b-col>
        </b-row>
        <b-row class="p-3" v-if="skeletonloading">
            <b-col lg="8" md="8" sm="12" cols="12">
                <div class="asset-stats-card">
                    <Skeleton height="1.5rem" width="100%" class="mb-4"></Skeleton>
                    <div class="d-flex justify-content-around">
                        <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
                        <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
                        <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
                        <Skeleton height="5rem" width="20%" class="mb-2"></Skeleton>
                    </div>
                </div>
            </b-col>
            <b-col lg="4" md="4" sm="12" cols="12">
                <div class="asset-stats-card">
                    <b-row>
                        <b-col cols="6">
                            <Skeleton height="4rem" width="20%" class="mb-0"></Skeleton>
                        </b-col>
                        <b-col cols="6">
                            <Skeleton height="4rem" width="20%" class="mb-0"></Skeleton>
                        </b-col>
                        <b-col cols="6" class="mt-2">
                            <Skeleton height="4rem" width="20%" class="mb-0"></Skeleton>
                        </b-col>
                        <b-col cols="6" class="mt-2">
                            <Skeleton height="4rem" width="20%" class="mb-0"></Skeleton>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
            <b-col>
                <SkeletonTableLoader :columns="headers" :loading="skeletonloading" />
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col lg="8" md="8" sm="12" cols="12">
                <div class="asset-stats-card" v-if="!skeletonloading">
                    <div class="stats-grid">
                        <div class="stat-item">
                            <i class="pi pi-database"></i>
                            <span class="stat-label">{{
                                t("assetManagement.maintenancedetails.TotalAssets")
                                }}:</span>
                            <span class="stat-value total">
                                {{ DetailsData?.TotalAsset || 0 }}</span>
                        </div>
                        <div class="stat-item">
                            <i class="pi pi-clock"></i>
                            <span class="stat-label">{{ t("assetManagement.maintenancedetails.Pending") }}:</span>
                            <span class="stat-value assigned">{{
                                DetailsData?.AssetAvailability || 0
                                }}</span>
                        </div>
                        <div class="stat-item">
                            <i class="pi pi-exclamation-triangle"></i>
                            <span class="stat-label">{{ t("assetManagement.maintenancedetails.Overdue") }}:</span>
                            <span class="stat-value unassigned">{{
                                DetailsData?.AssetInUse || 0
                                }}</span>
                        </div>
                        <div class="stat-item">
                            <i class="pi pi-flag"></i>
                            <span class="stat-label">{{ t("assetManagement.maintenancedetails.Escalated") }}:</span>
                            <span class="stat-value in-use">{{
                                DetailsData?.MaintenaceDue || 0
                                }}</span>
                        </div>
                    </div>
                </div>
            </b-col>
            <b-col lg="4" md="4" sm="12" cols="12">
                <div class="asset-stats-card">
                    <b-row>
                        <b-col cols="6">
                            <Button class="action-button analytics-btn w-full p-button-raised" size="small"
                                severity="info">
                                <i class="pi pi-chart-bar mr-2"></i>
                                {{ t("assetManagement.maintenancedetails.analyticsreport") }}
                            </Button>
                        </b-col>
                        <b-col cols="6">
                            <Button class="action-button order-btn w-full p-button-raised" size="small"
                                severity="primary">
                                <i class="pi pi-shopping-cart mr-2"></i>
                                {{ t("assetManagement.maintenancedetails.orderspareparts") }}
                            </Button>
                        </b-col>
                        <b-col cols="6" class="mt-2">
                            <Button class="action-button history-btn w-full p-button-raised" size="small"
                                severity="secondary">
                                <i class="pi pi-history mr-2"></i>
                                {{ t("assetManagement.maintenancedetails.vieworderhistory") }}
                            </Button>
                        </b-col>
                        <b-col cols="6" class="mt-2">
                            <Button class="action-button reports-btn w-full p-button-raised" size="small"
                                severity="success">
                                <i class="pi pi-file-pdf mr-2"></i>
                                {{ t("assetManagement.maintenancedetails.generatereports") }}
                            </Button>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
            <b-col llg="12" md="12" sm="12" cols="12" class="mt-3">
                <b-row>
                    <b-col cols="3">
                        <div class="field">
                            <CustomDropdown :label="$t('assetManagement.maintenancedetails.Filters.asset')"
                                v-model="FiltersObject.asset"
                                :name="$t('assetManagement.maintenancedetails.Filters.asset')"
                                :id="$t('assetManagement.maintenancedetails.Filters.asset')"
                                :items="FiltersObject.assetoptions" @change="FilterOnChnage('asset')" />
                        </div>
                    </b-col>
                    <b-col cols="3">
                        <div class="field">
                            <CustomDropdown :label="$t(
                                'assetManagement.maintenancedetails.Filters.maintenanceType'
                            )
                                " v-model="FiltersObject.maintenanceType" :name="$t(
                                    'assetManagement.maintenancedetails.Filters.maintenanceType'
                                )
                                    " :id="$t(
                                        'assetManagement.maintenancedetails.Filters.maintenanceType'
                                    )
                                        " :items="FiltersObject.maintenanceTypeoptions"
                                @change="FilterOnChnage('maintenanceType')" />
                        </div>
                    </b-col>
                    <b-col cols="3">
                        <div class="field">
                            <CustomDropdown :label="$t('assetManagement.maintenancedetails.Filters.status')"
                                v-model="FiltersObject.status"
                                :name="$t('assetManagement.maintenancedetails.Filters.status')"
                                :id="$t('assetManagement.maintenancedetails.Filters.status')"
                                :items="FiltersObject.statusoptions" @change="FilterOnChnage('status')" />
                        </div>
                    </b-col>
                    <b-col cols="3">
                        <div class="field">
                            <CustomDropdown :label="$t('assetManagement.maintenancedetails.Filters.warranty')
                                " v-model="FiltersObject.warranty" :name="$t('assetManagement.maintenancedetails.Filters.warranty')
                                    " :id="$t('assetManagement.maintenancedetails.Filters.warranty')"
                                :items="FiltersObject.warrantyoptions" @change="FilterOnChnage('warranty')" />
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <!-- Tab View with Tables -->
            <b-col lg="12" md="12" sm="12" cols="12" class="mt-3">
                <TabView @tab-change="onTabChange">
                    <TabPanel header="Scheduled">
                        <Tableview :value="scheduledList" :paginator="true"
                            class="p-datatable-gridlines commonstatusclass" :rows="10" :rowHover="true"
                            filterDisplay="menu" responsiveLayout="scroll" :columns="scheduledHeaders" @row-click=""
                            :globalFilterFields="scheduledGlobalFilterFields" :filters="scheduledFilters" @ShowRows=""
                            :exceldownload="true" :filterbtn="true" :statusFilterBtn="true">
                            <template v-slot:action="{ data }">
                                <span>
                                    <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                                        @click="toggle($event, data, 'scheduled')" size="small" text />
                                </span>
                            </template>

                            <template v-slot:status="{ data }">
                                <Tag :value="data.status" :severity="getStatusSeverity(data.status)" rounded />
                            </template>

                            <template v-slot:warranty="{ data }">
                                <Tag :value="data.warranty"
                                    :severity="data.warranty === 'Active' ? 'success' : 'danger'" rounded />
                            </template>

                            <template v-slot:maintenanceType="{ data }">
                                <Tag :value="data.maintenanceType"
                                    :severity="getMaintenanceTypeSeverity(data.maintenanceType)" rounded />
                            </template>
                        </Tableview>
                    </TabPanel>

                    <TabPanel header="Assigned">
                        <Tableview :value="assignedList" :paginator="true"
                            class="p-datatable-gridlines commonstatusclass" :rows="10" :rowHover="true"
                            filterDisplay="menu" responsiveLayout="scroll" :columns="assignedHeaders" @row-click=""
                            :globalFilterFields="assignedGlobalFilterFields" :filters="assignedFilters" @ShowRows=""
                            :exceldownload="true" :filterbtn="true" :statusFilterBtn="true">
                            <template v-slot:action="{ data }">
                                <span>
                                    <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                                        @click="toggle($event, data, 'assigned')" size="small" text />
                                </span>
                            </template>

                            <template v-slot:assignedTo="{ data }">
                                <div class="flex align-items-center">
                                    <Avatar :label="getInitials(data.assignedTo)" class="mr-2" size="small"
                                        style="background-color: #2196F3; color: #ffffff" />
                                    <span>{{ data.assignedTo }}</span>
                                </div>
                            </template>

                            <template v-slot:priority="{ data }">
                                <Tag :value="data.priority" :severity="getPrioritySeverity(data.priority)" rounded />
                            </template>

                            <template v-slot:status="{ data }">
                                <Tag :value="data.status" :severity="getStatusSeverity(data.status)" rounded />
                            </template>

                            <template v-slot:maintenanceType="{ data }">
                                <Tag :value="data.maintenanceType"
                                    :severity="getMaintenanceTypeSeverity(data.maintenanceType)" rounded />
                            </template>
                        </Tableview>
                    </TabPanel>

                    <TabPanel header="Completed">
                        <Tableview :value="completedList" :paginator="true"
                            class="p-datatable-gridlines commonstatusclass" :rows="10" :rowHover="true"
                            filterDisplay="menu" responsiveLayout="scroll" :columns="completedHeaders" @row-click=""
                            :globalFilterFields="completedGlobalFilterFields" :filters="completedFilters" @ShowRows=""
                            :exceldownload="true" :filterbtn="true" :statusFilterBtn="true">
                            <template v-slot:action="{ data }">
                                <span>
                                    <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                                        @click="toggle($event, data, 'completed')" size="small" text />
                                </span>
                            </template>

                            <template v-slot:completedBy="{ data }">
                                <div class="flex align-items-center">
                                    <Avatar :label="getInitials(data.completedBy)" class="mr-2" size="small"
                                        style="background-color: #4CAF50; color: #ffffff" />
                                    <span>{{ data.completedBy }}</span>
                                </div>
                            </template>

                            <template v-slot:cost="{ data }">
                                <span class="font-medium text-green-600">${{ data.cost }}</span>
                            </template>

                            <template v-slot:warranty="{ data }">
                                <Tag :value="data.warranty"
                                    :severity="data.warranty === 'Active' ? 'success' : 'danger'" rounded />
                            </template>

                            <template v-slot:maintenanceType="{ data }">
                                <Tag :value="data.maintenanceType"
                                    :severity="getMaintenanceTypeSeverity(data.maintenanceType)" rounded />
                            </template>
                        </Tableview>
                    </TabPanel>
                </TabView>
            </b-col>
        </b-row>
    </b-container>

    <!-- Context Menu -->
    <Menu ref="menu" id="overlay_menu" :model="actionlist" :popup="true" />

    <!-- Schedule Preventive Maintenance Dialog -->
    <Dialog v-model:visible="showScheduleDialog" modal :closable="false" :style="{ width: '50rem' }"
        :breakpoints="{ '960px': '75vw', '641px': '90vw' }" class="maintenance-dialog">
        <template #header>
            <b-container fluid>
                <b-row>
                    <b-col lg="6" md="6">
                        <h3 class="compo-heading ps-0 mb-0">
                            <i class="pi pi-calendar-plus mr-2 text-primary"></i>
                            Schedule Preventive Maintenance
                        </h3>
                    </b-col>
                    <b-col lg="6" md="6" class="d-flex flex-row-reverse">
                        <Button icon="pi pi-times" class="p-button-rounded p-button-text close-btn"
                            @click="showScheduleDialog = false" />
                    </b-col>
                </b-row>
            </b-container>
        </template>

        <div class="dialog-content">
            <Panel header="Schedule Details" class="border-round">
                <div class="grid p-fluid">
                    <div class="col-6">
                        <div class="field">
                            <label for="scheduleAsset" class="field-label">Asset <span
                                    class="required-star">*</span></label>
                            <Dropdown id="scheduleAsset" v-model="scheduleForm.asset" :options="assetOptions"
                                optionLabel="label" optionValue="value" placeholder="Select Asset" class="w-full" />
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="field">
                            <label for="scheduleMaintenanceType" class="field-label">Maintenance Type <span
                                    class="required-star">*</span></label>
                            <Dropdown id="scheduleMaintenanceType" v-model="scheduleForm.maintenanceType"
                                :options="maintenanceTypeOptions" optionLabel="label" optionValue="value"
                                placeholder="Select Type" class="w-full" />
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="field">
                            <label for="lastMaintenanceDate" class="field-label">Last Maintenance Date</label>
                            <InputText id="lastMaintenanceDate" v-model="scheduleForm.lastMaintenanceDate" readonly
                                class="readonly-input" />
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="field">
                            <label for="nextMaintenanceDate" class="field-label">Next Maintenance Date <span
                                    class="required-star">*</span></label>
                            <Calendar id="nextMaintenanceDate" v-model="scheduleForm.nextMaintenanceDate"
                                dateFormat="dd-mm-yy" showIcon class="w-full" />
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="field">
                            <label for="technician" class="field-label">Technician <span
                                    class="required-star">*</span></label>
                            <Dropdown id="technician" v-model="scheduleForm.technician" :options="technicianOptions"
                                optionLabel="label" optionValue="value" placeholder="Select Technician"
                                class="w-full" />
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="field">
                            <label for="scheduledDate" class="field-label">Scheduled Date <span
                                    class="required-star">*</span></label>
                            <Calendar id="scheduledDate" v-model="scheduleForm.scheduledDate" dateFormat="dd-mm-yy"
                                showIcon class="w-full" />
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="field">
                            <label for="estimatedCost" class="field-label">Estimated Cost</label>
                            <InputNumber id="estimatedCost" v-model="scheduleForm.estimatedCost" mode="currency"
                                currency="USD" locale="en-US" class="w-full" />
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="field">
                            <label for="scheduleNotes" class="field-label">Notes</label>
                            <Textarea id="scheduleNotes" v-model="scheduleForm.notes" rows="3" class="w-full"
                                placeholder="Add any additional notes..." />
                        </div>
                    </div>
                </div>
            </Panel>
        </div>

        <template #footer>
            <div class="dialog-footer flex gap-2 justify-content-end">
                <Button label="Cancel" icon="pi pi-times" severity="secondary" outlined
                    @click="showScheduleDialog = false" />
                <Button label="Save & Schedule" icon="pi pi-check" severity="primary" @click="saveSchedule" />
            </div>
        </template>
    </Dialog>

    <!-- Perform Maintenance Dialog -->
    <Dialog v-model:visible="showMaintenanceDialog" modal :closable="false" :style="{ width: '65rem' }"
        :breakpoints="{ '960px': '75vw', '641px': '90vw' }" maximizable class="maintenance-dialog">
        :breakpoints="{ '960px': '75vw', '641px': '90vw' }" maximizable class="maintenance-dialog">
        <template #header>
            <b-container fluid>
                <b-row>
                    <b-col lg="6" md="6">
                        <h3 class="compo-heading ps-0 mb-0">
                            <i class="pi pi-cog mr-2 text-primary"></i>
                            Perform Maintenance
                        </h3>
                    </b-col>
                    <b-col lg="6" md="6" class="d-flex flex-row-reverse">
                        <Button icon="pi pi-times" class="p-button-rounded p-button-text close-btn"
                            @click="showMaintenanceDialog = false" />
                    </b-col>
                </b-row>
            </b-container>
        </template>

        <div class="dialog-content maintenance-dialog-content">
            <!-- Asset Information Panel -->
            <Panel header="Asset Information" class="mb-4">
                <div class="grid p-fluid">
                    <div class="col-6">
                        <div class="field">
                            <label class="field-label">Maintenance ID</label>
                            <InputText v-model="maintenanceForm.maintenanceId" readonly class="readonly-input" />
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="field">
                            <label class="field-label">Type</label>
                            <InputText v-model="maintenanceForm.type" readonly class="readonly-input" />
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="field">
                            <label class="field-label">Scheduled Date</label>
                            <InputText v-model="maintenanceForm.scheduledDate" readonly class="readonly-input" />
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="field">
                            <label class="field-label">Technician</label>
                            <InputText v-model="maintenanceForm.technician" readonly class="readonly-input" />
                        </div>
                    </div>
                </div>
            </Panel>

            <!-- Maintenance Checklist Panel -->
            <Panel header="Maintenance Checklist" class="mb-4">
                <div class="checklist-container">
                    <div v-for="(item, index) in maintenanceForm.checklist" :key="index" class="checklist-item"
                        :class="{ 'completed': item.completed }">
                        <Checkbox v-model="item.completed" :inputId="`check-${index}`" binary
                            class="checklist-checkbox" />
                        <label :for="`check-${index}`" class="checklist-label">{{ item.task }}</label>
                    </div>
                </div>
            </Panel>

            <!-- Spare Parts Panel -->
            <Panel header="Spare Parts Used" class="mb-4">
                <div class="spare-parts-section">
                    <div class="add-spare-part flex gap-2 mb-3">
                        <InputText v-model="newSparePart" placeholder="Add spare part..." class="flex-1"
                            @keyup.enter="addSparePart" />
                        <Button icon="pi pi-plus" size="small" severity="success" @click="addSparePart" />
                    </div>
                    <div class="spare-parts-list">
                        <div v-for="(part, index) in maintenanceForm.spareParts" :key="index"
                            class="spare-part-item flex justify-content-between align-items-center mb-2">
                            <span class="part-name">{{ part }}</span>
                            <Button icon="pi pi-times" size="small" severity="danger" text
                                @click="removeSparePart(index)" />
                        </div>
                    </div>
                </div>
            </Panel>

            <!-- Work Details Panel -->
            <Panel header="Work Details" class="mb-4">
                <div class="grid p-fluid">
                    <div class="col-12">
                        <div class="field">
                            <label class="field-label">Additional Work Performed</label>
                            <Textarea v-model="maintenanceForm.additionalWork" rows="4"
                                placeholder="Describe any additional work performed..." />
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="field">
                            <label class="field-label">Maintenance Cost</label>
                            <InputNumber v-model="maintenanceForm.cost" mode="currency" currency="USD" locale="en-US" />
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="field">
                            <label class="field-label">Notes</label>
                            <Textarea v-model="maintenanceForm.notes" rows="3"
                                placeholder="Add any maintenance notes..." />
                        </div>
                    </div>
                </div>
            </Panel>
        </div>

        <template #footer>
            <div class="dialog-footer maintenance-footer flex gap-2 justify-content-end">
                <Button label="Save Progress" icon="pi pi-save" severity="secondary" outlined @click="saveProgress" />
                <Button label="Request Escalation" icon="pi pi-exclamation-triangle" severity="warning" outlined
                    @click="requestEscalation" />
                <Button label="Complete Maintenance" icon="pi pi-check" severity="success"
                    @click="completeMaintenance" />
            </div>
        </template>
    </Dialog>

    <!-- Asset Details Sidebar -->
    <Sidebar v-model:visible="showDetailsSidebar" position="right" :style="{ width: '35rem' }" :baseZIndex="1000"
        class="asset-details-sidebar" :showCloseIcon="true">

        <div v-if="selectedAssetForSidebar" class="sidebar-content">
            <!-- Asset Information Panel -->
            <Panel header="Asset Information" class="mb-4">
                <div class="asset-info-content">
                    <div class="asset-header mb-3">
                        <h4 class="asset-title m-0">{{ selectedAssetForSidebar.assetName }}</h4>
                        <Tag :value="selectedAssetForSidebar.status"
                            :severity="getStatusSeverity(selectedAssetForSidebar.status)" />
                    </div>

                    <div class="grid grid-cols-1 gap-3">
                        <div class="info-item">
                            <span class="info-label">Asset ID:</span>
                            <span class="info-value">{{ selectedAssetForSidebar.assetId || 'A001' }}</span>
                        </div>
                        <div class="info-item">
                            <span class="info-label">Maintenance Type:</span>
                            <Tag :value="selectedAssetForSidebar.maintenanceType"
                                :severity="getMaintenanceTypeSeverity(selectedAssetForSidebar.maintenanceType)"
                                size="small" />
                        </div>
                        <div class="info-item">
                            <span class="info-label">Last Maintenance:</span>
                            <span class="info-value">{{ selectedAssetForSidebar.lastMaintenance }}</span>
                        </div>
                        <div class="info-item">
                            <span class="info-label">Next Maintenance:</span>
                            <span class="info-value">{{ selectedAssetForSidebar.nextMaintenance }}</span>
                        </div>
                        <div class="info-item">
                            <span class="info-label">Warranty Status:</span>
                            <Tag :value="selectedAssetForSidebar.warranty"
                                :severity="selectedAssetForSidebar.warranty === 'Active' ? 'success' : 'danger'"
                                size="small" />
                        </div>
                    </div>
                </div>
            </Panel>

            <!-- Maintenance History Panel -->
            <Panel header="Recent Maintenance Log" class="mb-4">
                <div class="timeline-container">
                    <div class="timeline-item">
                        <div class="timeline-content">
                            <div class="timeline-header">
                                <span class="timeline-date">01-Jan-2024</span>
                                <Tag value="Completed" severity="success" size="small" />
                            </div>
                            <div class="timeline-details">
                                <div class="detail-item">
                                    <i class="pi pi-user mr-2"></i>
                                    <span>John Doe</span>
                                </div>
                                <div class="detail-item">
                                    <i class="pi pi-tag mr-2"></i>
                                    <span>Preventive</span>
                                </div>
                                <div class="detail-item">
                                    <i class="pi pi-wrench mr-2"></i>
                                    <span>System check, calibration</span>
                                </div>
                                <div class="detail-item">
                                    <i class="pi pi-dollar mr-2"></i>
                                    <span class="text-green-600 font-semibold">$450</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Panel>

            <!-- Action Buttons Panel -->
            <Panel header="Quick Actions">
                <div class="action-buttons-grid flex flex-column gap-2">
                    <Button label="View Full History" icon="pi pi-history" severity="secondary" size="small" outlined
                        class="w-full justify-content-start" />
                    <Button label="Schedule Next" icon="pi pi-calendar-plus" severity="primary" size="small"
                        @click="scheduleNext(selectedAssetForSidebar)" class="w-full justify-content-start" />
                    <Button label="Start Adhoc" icon="pi pi-play" severity="success" size="small"
                        @click="startAdhoc(selectedAssetForSidebar)" class="w-full justify-content-start" />
                    <Button label="Update Asset Info" icon="pi pi-pencil" severity="info" size="small" outlined
                        class="w-full justify-content-start" />
                    <Button label="View/Update Warranty" icon="pi pi-shield" severity="warning" size="small" outlined
                        class="w-full justify-content-start" />
                </div>
            </Panel>
        </div>
    </Sidebar>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import BackToMasters from "../../../../../../../components/FormComponents/BacktoMaster.vue";
import AssetMasterService from "../../../../../Service/AssetManagement/AssetMasterService";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
import CustomDropdown from "../../../../../../../components/FormComponents/Dropdown.vue";

// PrimeVue Components
import Sidebar from 'primevue/sidebar';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import InputNumber from 'primevue/inputnumber';
import Textarea from 'primevue/textarea';
import Panel from 'primevue/panel';

export default defineComponent({
    components: {
        BackToMasters,
        SkeletonTableLoader,
        Tableview,
        CustomDropdown,
        Sidebar,
        Dialog,
        Button,
        InputText,
        Dropdown,
        Calendar,
        InputNumber,
        Textarea,
        Panel,
    },

    setup() {
        const { t } = useI18n();
        const skeletonloading = ref(false);
        const router = useRouter();
        const routes = useRoute();
        const DetailsData = ref();
        const menu = ref();

        // Data lists for different tabs
        const scheduledList = ref<any[]>([]);
        const assignedList = ref<any[]>([]);
        const completedList = ref<any[]>([]);
        const selectedAssetForSidebar = ref(null);
        const currentTab = ref('scheduled');

        // Dialog states
        const showScheduleDialog = ref(false);
        const showMaintenanceDialog = ref(false);
        const showDetailsSidebar = ref(false);

        // Form data
        const scheduleForm = ref({
            asset: null,
            maintenanceType: null,
            lastMaintenanceDate: '',
            nextMaintenanceDate: null,
            technician: null,
            scheduledDate: null,
            estimatedCost: null,
            notes: ''
        });

        const maintenanceForm = ref({
            maintenanceId: '',
            type: '',
            scheduledDate: '',
            technician: '',
            checklist: [
                { task: 'Calibrate sensors', completed: false },
                { task: 'Check magnetic field strength', completed: false },
                { task: 'Inspect cooling system', completed: false },
                { task: 'Test emergency shutdown', completed: false },
                { task: 'Update software', completed: false }
            ],
            spareParts: [],
            additionalWork: '',
            cost: null,
            notes: ''
        });

        const newSparePart = ref('');

        // Options data
        const assetOptions = ref([
            { label: 'MRI Scanner', value: 'mri' },
            { label: 'Ultrasound', value: 'ultrasound' },
            { label: 'CT Scanner', value: 'ct' },
            { label: 'X-Ray Machine', value: 'xray' }
        ]);

        const maintenanceTypeOptions = ref([
            { label: 'Preventive', value: 'preventive' },
            { label: 'Adhoc', value: 'adhoc' },
            { label: 'Emergency', value: 'emergency' }
        ]);

        const technicianOptions = ref([
            { label: 'John Doe', value: 'john' },
            { label: 'Jane Smith', value: 'jane' },
            { label: 'Mike Johnson', value: 'mike' },
            { label: 'Sarah Wilson', value: 'sarah' }
        ]);

        const ParamValues = ref({
            StoreId: Number(routes.query.StoreId ?? 0),
            BranchId: Number(routes.query.BranchId ?? 0),
        });

        let FiltersObject: any = ref({
            asset: 0,
            assetoptions: [],
            maintenanceType: 0,
            maintenanceTypeoptions: [],
            status: 0,
            statusoptions: [],
            warranty: 0,
            warrantyoptions: [],
        });

        let CommonObject = ref({
            sidebaropen: false,
            sidebarheading: "",
        });

        let SessionUserData = localStorage.getItem("UsersData");
        let usersData;
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }

        const headers = [
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.sno"),
                field: "sno",
                class: "filterdisplaynone",
            },
            {
                header: t(
                    "assetManagement.maintenancedetails.dashboardtable.assetname"
                ),
                field: "assetName",
                slot: "status",
                sortable: false,
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "mediumwidth",
                bodyclass: "boldclass text_overflow2",
            },
            {
                header: t(
                    "assetManagement.maintenancedetails.dashboardtable.maintenanceType"
                ),
                field: "maintenanceType",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
            },
            {
                header: t(
                    "assetManagement.maintenancedetails.dashboardtable.lastmaintenance"
                ),
                field: "lastMaintenance",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
            },
            {
                header: t(
                    "assetManagement.maintenancedetails.dashboardtable.nextmaintenance"
                ),
                field: "nextMaintenance",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
            },
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.status"),
                field: "status",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
            },
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.warranty"),
                field: "warranty",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
            },
            {
                field: "action",
                header: "",
                slot: "action",
                frozencolumn: true,
                sortable: false,
                hide: false,
                class: "filterdisplaynone last-column-position",
                fieldDisplay: "false",
            },
        ];

        // Headers for Scheduled tab
        const scheduledHeaders = ref([
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.sno"),
                field: "sno",
                class: "filterdisplaynone",
            },
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.assetname"),
                field: "assetName",
                sortable: true,
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "mediumwidth",
                bodyclass: "boldclass text_overflow2",
            },
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.maintenanceType"),
                field: "maintenanceType",
                slot: "maintenanceType",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.lastmaintenance"),
                field: "lastMaintenance",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.nextmaintenance"),
                field: "nextMaintenance",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.status"),
                field: "status",
                slot: "status",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.warranty"),
                field: "warranty",
                slot: "warranty",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                field: "action",
                header: "",
                slot: "action",
                frozencolumn: true,
                sortable: false,
                hide: false,
                class: "filterdisplaynone last-column-position",
                fieldDisplay: "false",
            },
        ]);

        // Headers for Assigned tab
        const assignedHeaders = ref([
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.sno"),
                field: "sno",
                class: "filterdisplaynone",
            },
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.assetname"),
                field: "assetName",
                sortable: true,
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "mediumwidth",
                bodyclass: "boldclass text_overflow2",
            },
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.maintenanceType"),
                field: "maintenanceType",
                slot: "maintenanceType",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                header: "Assigned To",
                field: "assignedTo",
                slot: "assignedTo",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                header: "Assigned Date",
                field: "assignedDate",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                header: "Priority",
                field: "priority",
                slot: "priority",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                header: "Duration",
                field: "estimatedDuration",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.status"),
                field: "status",
                slot: "status",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                field: "action",
                header: "",
                slot: "action",
                frozencolumn: true,
                sortable: false,
                hide: false,
                class: "filterdisplaynone last-column-position",
                fieldDisplay: "false",
            },
        ]);

        // Headers for Completed tab
        const completedHeaders = ref([
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.sno"),
                field: "sno",
                class: "filterdisplaynone",
            },
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.assetname"),
                field: "assetName",
                sortable: true,
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "mediumwidth",
                bodyclass: "boldclass text_overflow2",
            },
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.maintenanceType"),
                field: "maintenanceType",
                slot: "maintenanceType",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                header: "Completed By",
                field: "completedBy",
                slot: "completedBy",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                header: "Completed Date",
                field: "completedDate",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                header: "Cost",
                field: "cost",
                slot: "cost",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.nextmaintenance"),
                field: "nextMaintenance",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                header: t("assetManagement.maintenancedetails.dashboardtable.warranty"),
                field: "warranty",
                slot: "warranty",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                sortable: true,
            },
            {
                field: "action",
                header: "",
                slot: "action",
                frozencolumn: true,
                sortable: false,
                hide: false,
                class: "filterdisplaynone last-column-position",
                fieldDisplay: "false",
            },
        ]);


        const globalFilterFields = ref(headers.map((col) => col.field));

        // Global filter fields for different tabs
        const scheduledGlobalFilterFields = ref(scheduledHeaders.value.map((col) => col.field));
        const assignedGlobalFilterFields = ref(assignedHeaders.value.map((col) => col.field));
        const completedGlobalFilterFields = ref(completedHeaders.value.map((col) => col.field));

        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            assetName: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: [],
            },
            maintenanceType: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: [],
            },
            lastMaintenance: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: [],
            },
            nextMaintenance: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: [],
            },
            status: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: [],
            },
            warranty: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: [],
            },
        };

        // Filters for different tabs
        const scheduledFilters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            assetName: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            maintenanceType: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            lastMaintenance: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            nextMaintenance: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            status: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            warranty: { value: null, matchMode: FilterMatchMode.IN, options: [] },
        });

        const assignedFilters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            assetName: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            maintenanceType: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            assignedTo: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            assignedDate: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            priority: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            estimatedDuration: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            status: { value: null, matchMode: FilterMatchMode.IN, options: [] },
        });

        const completedFilters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            assetName: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            maintenanceType: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            completedBy: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            completedDate: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            cost: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            nextMaintenance: { value: null, matchMode: FilterMatchMode.IN, options: [] },
            warranty: { value: null, matchMode: FilterMatchMode.IN, options: [] },
        });

        const toggle = (event, data, tabType) => {
            selectedAssetForSidebar.value = data;
            currentTab.value = tabType;
            updateActionMenu();
            menu.value.toggle(event);
        };

        const actionlist = ref([
            {
                items: [
                    {
                        label: "View",
                        icon: "pi pi-eye",
                        visible: true,
                        command: async () => {
                            showDetailsSidebar.value = true;
                        },
                    },
                    {
                        label: "Start Adhoc",
                        icon: "pi pi-bolt",
                        visible: true,
                        command: async () => {
                            startAdhoc(selectedAssetForSidebar.value);
                        },
                    },
                    {
                        label: "Assign",
                        icon: "pi pi-user-plus",
                        visible: true,
                        command: async () => {
                            OpenSidebar("Assign Technician");
                        },
                    },
                    {
                        label: "Schedule",
                        icon: "pi pi-calendar-plus",
                        visible: true,
                        command: async () => {
                            schedulePreventive(selectedAssetForSidebar.value);
                        },
                    },
                    {
                        label: "Perform Maintenance",
                        icon: "pi pi-cog",
                        visible: true,
                        command: async () => {
                            performMaintenance(selectedAssetForSidebar.value);
                        },
                    },
                ],
            },
        ]);

        onMounted(() => {
            IsShow();
        });

        async function IsShow() {
            debugger;
            try {
                skeletonloading.value = true;
                const dataresponse = await AssetMasterService.getListAssetDashBoard(
                    usersData.OrganizationId,
                    ParamValues.value.BranchId,
                    ParamValues.value.StoreId
                );
                DetailsData.value = dataresponse["result"];
                LoadMaintenanceDetails();
                skeletonloading.value = false;
            } catch (error) {
                console.log(error);
            }
        }

        function LoadMaintenanceDetails() {
            // Load Scheduled Assets
            scheduledList.value = [
                {
                    sno: 1,
                    assetName: "MRI Scanner - Siemens Magnetom",
                    maintenanceType: "Preventive",
                    lastMaintenance: "2024-11-15",
                    nextMaintenance: "2025-02-15",
                    status: "Scheduled",
                    warranty: "Active",
                },
                {
                    sno: 2,
                    assetName: "X-Ray Machine - GE Discovery",
                    maintenanceType: "Corrective",
                    lastMaintenance: "2024-12-20",
                    nextMaintenance: "2025-01-20",
                    status: "Overdue",
                    warranty: "Expired",
                },
                {
                    sno: 3,
                    assetName: "Ultrasound System - Philips EPIQ",
                    maintenanceType: "Preventive",
                    lastMaintenance: "2024-12-10",
                    nextMaintenance: "2025-03-10",
                    status: "Pending",
                    warranty: "Active",
                },
            ];

            // Load Assigned Assets
            assignedList.value = [
                {
                    sno: 1,
                    assetName: "CT Scanner - Toshiba Aquilion",
                    maintenanceType: "Emergency",
                    assignedTo: "Jane Smith",
                    assignedDate: "2024-12-28",
                    priority: "High",
                    estimatedDuration: "4 hours",
                    status: "In Progress",
                },
                {
                    sno: 2,
                    assetName: "Ventilator - Medtronic PB980",
                    maintenanceType: "Preventive",
                    assignedTo: "Mike Johnson",
                    assignedDate: "2024-12-25",
                    priority: "Medium",
                    estimatedDuration: "6 hours",
                    status: "Assigned",
                },
            ];

            // Load Completed Assets
            completedList.value = [
                {
                    sno: 1,
                    assetName: "Defibrillator - Philips HeartStart",
                    maintenanceType: "Preventive",
                    completedBy: "Sarah Wilson",
                    completedDate: "2024-12-20",
                    cost: "450",
                    nextMaintenance: "2025-03-20",
                    warranty: "Active",
                },
                {
                    sno: 2,
                    assetName: "ECG Machine - GE MAC 2000",
                    maintenanceType: "Corrective",
                    completedBy: "John Doe",
                    completedDate: "2024-12-18",
                    cost: "320",
                    nextMaintenance: "2025-06-18",
                    warranty: "Extended",
                },
            ];

            LoadFilters();
        }

        function LoadFilters() {
            // Combine all data for filter options
            const allData = [...scheduledList.value, ...assignedList.value, ...completedList.value];

            FiltersObject.value.assetoptions = getUniqueOptions(allData, "assetName");
            FiltersObject.value.maintenanceTypeoptions = getUniqueOptions(allData, "maintenanceType");
            FiltersObject.value.statusoptions = getUniqueOptions(allData, "status");
            FiltersObject.value.warrantyoptions = getUniqueOptions(allData, "warranty");

            // Helper to get unique values from items array for a given key
            function getUniqueOptions(dataArray, key) {
                const seen = new Set();
                return dataArray
                    .map((item) => item[key])
                    .filter((val) => {
                        if (!val || seen.has(val)) return false;
                        seen.add(val);
                        return true;
                    })
                    .map((val) => ({
                        name: val,
                        value: val,
                    }));
            }
        }

        function FilterOnChnage(filtervalue) {
            let value = filtervalue === "asset" ? FiltersObject.value.asset :
                filtervalue === "maintenanceType" ? FiltersObject.value.maintenanceType :
                    filtervalue === "status" ? FiltersObject.value.status :
                        FiltersObject.value.warranty;

            // Apply filters to current tab data
            applyFilters();
        }

        function applyFilters() {
            // Implementation for applying filters across tabs
            console.log('Applying filters across tabs');
        }

        function onTabChange(event) {
            currentTab.value = event.index === 0 ? 'scheduled' :
                event.index === 1 ? 'assigned' : 'completed';

            // Update action menu based on current tab
            updateActionMenu();
        }

        function updateActionMenu() {
            if (currentTab.value === 'assigned') {
                actionlist.value[0].items = [
                    { label: "View", icon: "pi pi-eye", visible: true, command: () => { showDetailsSidebar.value = true; } },
                    { label: "Perform Maintenance", icon: "pi pi-cog", visible: true, command: () => performMaintenance(selectedAssetForSidebar.value) },
                    { label: "Escalate", icon: "pi pi-exclamation-triangle", visible: true, command: () => OpenSidebar("Escalate Issue") },
                ];
            } else if (currentTab.value === 'completed') {
                actionlist.value[0].items = [
                    { label: "View", icon: "pi pi-eye", visible: true, command: () => { showDetailsSidebar.value = true; } },
                    { label: "Schedule Next", icon: "pi pi-calendar-plus", visible: true, command: () => schedulePreventive(selectedAssetForSidebar.value) },
                ];
            } else {
                actionlist.value[0].items = [
                    { label: "View", icon: "pi pi-eye", visible: true, command: () => { showDetailsSidebar.value = true; } },
                    { label: "Start Adhoc", icon: "pi pi-bolt", visible: true, command: () => startAdhoc(selectedAssetForSidebar.value) },
                    { label: "Assign", icon: "pi pi-user-plus", visible: true, command: () => OpenSidebar("Assign Technician") },
                    { label: "Schedule", icon: "pi pi-calendar-plus", visible: true, command: () => schedulePreventive(selectedAssetForSidebar.value) },
                ];
            }
        }

        // Dialog action methods
        function schedulePreventive(asset) {
            scheduleForm.value = {
                asset: { label: asset.assetName, value: asset.assetId },
                maintenanceType: null,
                lastMaintenanceDate: asset.lastMaintenance || '',
                nextMaintenanceDate: null,
                technician: null,
                scheduledDate: null,
                estimatedCost: null,
                notes: ''
            };
            showScheduleDialog.value = true;
        }

        function performMaintenance(asset) {
            maintenanceForm.value = {
                maintenanceId: `M${Math.floor(Math.random() * 10000)}`,
                type: asset.maintenanceType,
                scheduledDate: asset.assignedDate || asset.lastMaintenance,
                technician: asset.assignedTo || 'Not Assigned',
                checklist: [
                    { task: 'Calibrate sensors', completed: false },
                    { task: 'Check magnetic field strength', completed: false },
                    { task: 'Inspect cooling system', completed: false },
                    { task: 'Test emergency shutdown', completed: false },
                    { task: 'Update software', completed: false }
                ],
                spareParts: [],
                additionalWork: '',
                cost: null,
                notes: ''
            };
            showMaintenanceDialog.value = true;
        }

        function startAdhoc(asset) {
            console.log('Starting adhoc maintenance for:', asset.assetName);
            // Implementation for starting adhoc maintenance
        }

        function scheduleNext(asset) {
            schedulePreventive(asset);
            showDetailsSidebar.value = false;
        }

        function saveSchedule() {
            console.log('Saving schedule:', scheduleForm.value);
            showScheduleDialog.value = false;
        }

        function addSparePart() {
            if (newSparePart.value.trim()) {
                maintenanceForm.value.spareParts.push(newSparePart.value.trim());
                newSparePart.value = '';
            }
        }

        function removeSparePart(index) {
            maintenanceForm.value.spareParts.splice(index, 1);
        }

        function saveProgress() {
            console.log('Saving progress:', maintenanceForm.value);
        }

        function requestEscalation() {
            console.log('Requesting escalation:', maintenanceForm.value);
        }

        function completeMaintenance() {
            console.log('Completing maintenance:', maintenanceForm.value);
            showMaintenanceDialog.value = false;
        }

        function OpenSidebar(sidebarheading) {
            CommonObject.value.sidebaropen = true;
            CommonObject.value.sidebarheading = sidebarheading;
        }

        function CloseSidebar() {
            CommonObject.value.sidebaropen = false;
            selectedAssetForSidebar.value = null;
        }

        function closeSidebars() {
            showDetailsSidebar.value = false;
            showScheduleDialog.value = false;
            showMaintenanceDialog.value = false;
        }

        // Utility functions
        function getStatusSeverity(status) {
            const severityMap = {
                'Scheduled': 'info',
                'Pending': 'warning',
                'Overdue': 'danger',
                'In Progress': 'success',
                'Assigned': 'info',
                'Completed': 'success'
            };
            return severityMap[status] || 'secondary';
        }

        function getMaintenanceTypeSeverity(type) {
            const severityMap = {
                'Preventive': 'info',
                'Corrective': 'warning',
                'Emergency': 'danger'
            };
            return severityMap[type] || 'secondary';
        }

        function getPrioritySeverity(priority) {
            const severityMap = {
                'Low': 'success',
                'Medium': 'info',
                'High': 'warning',
                'Critical': 'danger'
            };
            return severityMap[priority] || 'secondary';
        }

        function getInitials(name) {
            return name.split(' ').map(n => n[0]).join('').toUpperCase();
        }

        return {
            skeletonloading,
            ParamValues,
            t,
            DetailsData,
            headers,
            scheduledHeaders,
            assignedHeaders,
            completedHeaders,
            globalFilterFields,
            scheduledGlobalFilterFields,
            assignedGlobalFilterFields,
            completedGlobalFilterFields,
            scheduledList,
            assignedList,
            completedList,
            filters,
            scheduledFilters,
            assignedFilters,
            completedFilters,
            FiltersObject,
            CommonObject,
            selectedAssetForSidebar,
            currentTab,
            CloseSidebar,
            closeSidebars,
            toggle,
            menu,
            actionlist,
            FilterOnChnage,
            onTabChange,
            getStatusSeverity,
            getMaintenanceTypeSeverity,
            getPrioritySeverity,
            getInitials,
            // Dialog states
            showScheduleDialog,
            showMaintenanceDialog,
            showDetailsSidebar,
            // Form data
            scheduleForm,
            maintenanceForm,
            newSparePart,
            // Options
            assetOptions,
            maintenanceTypeOptions,
            technicianOptions,
            // Dialog methods
            schedulePreventive,
            performMaintenance,
            startAdhoc,
            scheduleNext,
            saveSchedule,
            addSparePart,
            removeSparePart,
            saveProgress,
            requestEscalation,
            completeMaintenance,
        };
    },
});
</script>

<style scoped>
/* Existing Action Button Styles */
.action-button {
    width: 100%;
    height: 100%;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-start !important;
    padding: 0.55rem 1rem !important;
    border-radius: 8px !important;
    font-weight: 500 !important;
    transition: all 0.3s ease !important;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1) !important;
    text-align: left !important;
    font-size: 0.85rem !important;
    color: white !important;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2) !important;
}

.action-button:hover {
    transform: translateY(-2px) !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.action-button i {
    margin-right: 0.5rem !important;
    font-size: 1rem !important;
}

/* Custom button colors */
.analytics-btn {
    background-color: #4361ee !important;
    border-color: #4361ee !important;
}

.order-btn {
    background-color: #ff9f1c !important;
    border-color: #ff9f1c !important;
}

.history-btn {
    background-color: #4cc9f0 !important;
    border-color: #4cc9f0 !important;
}

.reports-btn {
    background-color: #2a9d8f !important;
    border-color: #2a9d8f !important;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
    padding: 1rem;
}

.stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 1rem;
    background: #f8f9fa;
    border-radius: 8px;
}

.stat-item i {
    font-size: 2rem;
    margin-bottom: 0.5rem;
    color: #007bff;
}

.stat-label {
    font-size: 0.9rem;
    color: #6c757d;
    margin-bottom: 0.25rem;
}

.stat-value {
    font-size: 1.5rem;
    font-weight: bold;
}

.stat-value.total {
    color: #007bff;
}

.stat-value.assigned {
    color: #28a745;
}

.stat-value.unassigned {
    color: #dc3545;
}

.stat-value.in-use {
    color: #ffc107;
}

.asset-stats-card {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 1rem;
    margin-bottom: 1rem;
}

/* Dialog Styles */
.maintenance-dialog :deep(.p-dialog) {
    border-radius: 16px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    overflow: hidden;
}

.maintenance-dialog :deep(.p-dialog-header) {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-radius: 16px 16px 0 0;
    padding: 1.25rem 1.5rem;
    border-bottom: none;
}

.maintenance-dialog :deep(.p-dialog-content) {
    padding: 0;
    border-radius: 0 0 16px 16px;
    background: #f8f9fa;
}

.maintenance-dialog :deep(.p-dialog-footer) {
    background: white;
    border-top: 1px solid #e9ecef;
    border-radius: 0 0 16px 16px;
    padding: 1.25rem 1.5rem;
}

.compo-heading {
    font-size: 1.3rem;
    font-weight: 600;
    color: white;
    margin: 0;
    display: flex;
    align-items: center;
}

.compo-heading i {
    margin-right: 0.75rem;
    font-size: 1.4rem;
}

.close-btn {
    color: white !important;
    background: rgba(255, 255, 255, 0.1) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    transition: all 0.3s ease !important;
    padding: 0.5rem !important;
    min-width: 2.5rem !important;
    height: 2.5rem !important;
}

.close-btn:hover {
    background: rgba(255, 255, 255, 0.2) !important;
    border-color: rgba(255, 255, 255, 0.3) !important;
    transform: scale(1.05) !important;
}

.close-btn:focus {
    box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.3) !important;
}

.dialog-content {
    padding: 1.75rem;
    max-height: 70vh;
    overflow-y: auto;
}

.maintenance-dialog-content {
    max-height: 75vh;
}

.section-heading {
    font-size: 1.15rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 1.25rem;
    display: flex;
    align-items: center;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #e9ecef;
}

.section-heading i {
    margin-right: 0.75rem;
    font-size: 1.2rem;
}

.field {
    margin-bottom: 1.25rem;
}

.field-label {
    display: block;
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.6rem;
    font-size: 0.95rem;
}

.required-star {
    color: #dc3545;
    margin-left: 3px;
    font-weight: bold;
}

.dialog-input,
.dialog-dropdown,
.dialog-calendar,
.dialog-textarea {
    border: 2px solid #e9ecef;
    border-radius: 8px;
    transition: all 0.3s ease;
    font-size: 0.95rem;
    padding: 0.75rem;
}

.dialog-input:focus,
.dialog-dropdown:focus-within,
.dialog-calendar:focus-within,
.dialog-textarea:focus {
    border-color: #4361ee;
    box-shadow: 0 0 0 0.2rem rgba(67, 97, 238, 0.25);
    transform: translateY(-1px);
}

.readonly-input {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    color: #6c757d;
    cursor: not-allowed;
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    flex-wrap: wrap;
}

.maintenance-footer {
    justify-content: space-between;
    gap: 0.75rem;
}

.footer-btn {
    min-width: 130px;
    padding: 0.875rem 1.75rem;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.3s ease;
    font-size: 0.95rem;
    border-width: 2px;
}

.primary-btn {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    box-shadow: 0 4px 12px rgba(67, 97, 238, 0.3);
}

.primary-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(67, 97, 238, 0.4);
}

.footer-btn[severity="secondary"] {
    background: white;
    border-color: #6c757d;
    color: #6c757d;
}

.footer-btn[severity="secondary"]:hover {
    background: #6c757d;
    color: white;
    transform: translateY(-1px);
}

.footer-btn[severity="warning"] {
    background: white;
    border-color: #ffc107;
    color: #856404;
}

.footer-btn[severity="warning"]:hover {
    background: #ffc107;
    color: #856404;
    transform: translateY(-1px);
}

.footer-btn[severity="success"] {
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    border: none;
    color: white;
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.footer-btn[severity="success"]:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(40, 167, 69, 0.4);
}

/* Checklist Styles */
.checklist-container {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 12px;
    padding: 1.25rem;
    border: 2px solid #e9ecef;
}

.checklist-item {
    display: flex;
    align-items: center;
    padding: 1rem;
    margin-bottom: 0.75rem;
    background: white;
    border-radius: 10px;
    border: 2px solid #e9ecef;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.checklist-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 4px;
    background: #e9ecef;
    transition: all 0.3s ease;
}

.checklist-item:hover {
    border-color: #4361ee;
    transform: translateX(8px);
    box-shadow: 0 4px 12px rgba(67, 97, 238, 0.15);
}

.checklist-item:hover::before {
    background: #4361ee;
}

.checklist-item.completed {
    background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
    border-color: #28a745;
}

.checklist-item.completed::before {
    background: #28a745;
}

.checklist-checkbox {
    margin-right: 1rem;
    transform: scale(1.2);
}

.checklist-label {
    flex: 1;
    margin: 0;
    cursor: pointer;
    font-weight: 500;
    font-size: 0.95rem;
    color: #495057;
    transition: color 0.3s ease;
}

.checklist-item.completed .checklist-label {
    color: #155724;
    text-decoration: line-through;
}

/* Spare Parts Styles */
.spare-parts-section {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 12px;
    padding: 1.25rem;
    border: 2px solid #e9ecef;
}

.add-spare-part {
    display: flex;
    gap: 0.75rem;
    margin-bottom: 1.25rem;
    align-items: end;
}

.spare-part-input {
    flex: 1;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    padding: 0.75rem;
    font-size: 0.95rem;
    transition: all 0.3s ease;
}

.spare-part-input:focus {
    border-color: #28a745;
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.add-part-btn {
    min-width: 48px;
    height: 48px;
    border-radius: 8px;
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    border: none;
    transition: all 0.3s ease;
}

.add-part-btn:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.spare-parts-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.spare-part-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    padding: 1rem 1.25rem;
    border-radius: 10px;
    border: 2px solid #e9ecef;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.spare-part-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 4px;
    background: #28a745;
    transition: all 0.3s ease;
}

.spare-part-item:hover {
    border-color: #28a745;
    transform: translateX(8px);
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.15);
}

.part-name {
    font-weight: 500;
    color: #495057;
    font-size: 0.95rem;
}

.remove-part-btn {
    opacity: 0.7;
    transition: all 0.3s ease;
    background: #dc3545;
    border: none;
    border-radius: 6px;
}

.remove-part-btn:hover {
    opacity: 1;
    transform: scale(1.1);
    box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
}

/* Enhanced Surface Card Styles */
.surface-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    border: 2px solid #e9ecef;
    transition: all 0.3s ease;
    overflow: hidden;
    position: relative;
}

.surface-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
}

.surface-card:hover {
    border-color: #4361ee;
    box-shadow: 0 4px 20px rgba(67, 97, 238, 0.15);
    transform: translateY(-2px);
}

/* Form Enhancement */
.grid.p-fluid .field .dialog-dropdown :deep(.p-dropdown),
.grid.p-fluid .field .dialog-calendar :deep(.p-calendar),
.grid.p-fluid .field .dialog-input,
.grid.p-fluid .field .dialog-textarea {
    width: 100%;
    border-radius: 8px;
    font-size: 0.95rem;
}

.grid.p-fluid .field .dialog-dropdown :deep(.p-dropdown-trigger) {
    border-radius: 0 8px 8px 0;
}

.grid.p-fluid .field .dialog-calendar :deep(.p-datepicker-trigger) {
    border-radius: 0 8px 8px 0;
}

/* Input Number Styling */
.dialog-input[type="number"] :deep(.p-inputnumber-input) {
    text-align: right;
    font-weight: 500;
}

/* Placeholder Styling */
.dialog-input::placeholder,
.dialog-textarea::placeholder {
    color: #adb5bd;
    font-style: italic;
}

/* Focus States */
.dialog-dropdown:focus-within :deep(.p-dropdown),
.dialog-calendar:focus-within :deep(.p-calendar),
.dialog-input:focus,
.dialog-textarea:focus {
    border-color: #4361ee;
    box-shadow: 0 0 0 0.2rem rgba(67, 97, 238, 0.25);
}

/* Disabled States */
.dialog-input:disabled,
.dialog-textarea:disabled {
    background: linear-gradient(135deg, #f1f3f4 0%, #e9ecef 100%);
    color: #6c757d;
    cursor: not-allowed;
    opacity: 0.8;
}

/* Sidebar Styles */
.asset-details-sidebar :deep(.p-sidebar-content) {
    padding: 0;
    background: #f8f9fa;
}

.sidebar-custom-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 1.25rem 1.5rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    position: sticky;
    top: 0;
    z-index: 10;
}

.sidebar-header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.sidebar-header-left {
    display: flex;
    align-items: center;
    flex: 1;
}

.sidebar-icon {
    font-size: 1.3rem;
    margin-right: 0.75rem;
    color: white;
}

.sidebar-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: white;
    margin: 0;
}

.sidebar-close-btn {
    color: white !important;
    background: rgba(255, 255, 255, 0.1) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    transition: all 0.3s ease !important;
    padding: 0.5rem !important;
    min-width: 2.5rem !important;
    height: 2.5rem !important;
}

.sidebar-close-btn:hover {
    background: rgba(255, 255, 255, 0.2) !important;
    border-color: rgba(255, 255, 255, 0.3) !important;
    transform: scale(1.05) !important;
}

.sidebar-close-btn:focus {
    box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.3) !important;
}

.sidebar-content {
    padding: 1.5rem;
    height: calc(100vh - 80px);
    overflow-y: auto;
}

.sidebar-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    transition: all 0.3s ease;
    border: 1px solid #e9ecef;
}

.sidebar-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
    border-color: #4361ee;
}

.card-header {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    padding: 1.25rem 1.5rem;
    border-bottom: 1px solid #e9ecef;
}

.card-title {
    font-size: 1.05rem;
    font-weight: 600;
    color: #495057;
    margin: 0;
    display: flex;
    align-items: center;
}

.asset-title-section {
    padding: 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

.asset-title {
    font-size: 1.15rem;
    font-weight: 600;
    color: #495057;
    margin: 0;
    flex: 1;
    line-height: 1.4;
}

.status-tag {
    margin-left: 1rem;
    font-weight: 500;
}

.asset-info-grid {
    padding: 0 1.5rem 1.5rem;
}

.info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.875rem 0;
    border-bottom: 1px solid #f1f3f4;
    transition: all 0.2s ease;
}

.info-row:hover {
    background-color: #f8f9fa;
    margin: 0 -0.5rem;
    padding: 0.875rem 0.5rem;
    border-radius: 6px;
}

.info-row:last-child {
    border-bottom: none;
}

.info-label {
    font-weight: 500;
    color: #6c757d;
    font-size: 0.9rem;
}

.info-value {
    font-weight: 500;
    color: #495057;
    text-align: right;
    font-size: 0.9rem;
}

/* Timeline Styles */
.maintenance-timeline {
    padding: 1.5rem;
}

.timeline-item {
    display: flex;
    position: relative;
    padding-left: 2.5rem;
}

.timeline-marker {
    position: absolute;
    left: 0;
    top: 0.5rem;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4361ee 0%, #667eea 100%);
    border: 3px solid white;
    box-shadow: 0 2px 8px rgba(67, 97, 238, 0.3);
}

.timeline-content {
    flex: 1;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    border-radius: 10px;
    padding: 1.25rem;
    border: 1px solid #e9ecef;
    position: relative;
}

.timeline-content::before {
    content: '';
    position: absolute;
    left: -8px;
    top: 12px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px 8px 8px 0;
    border-color: transparent #f8f9fa transparent transparent;
}

.timeline-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid #e9ecef;
}

.timeline-date {
    font-weight: 600;
    color: #495057;
    font-size: 0.95rem;
}

.timeline-details {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
}

.detail-row {
    display: flex;
    align-items: center;
    font-size: 0.88rem;
    color: #6c757d;
    padding: 0.25rem 0;
}

.detail-row i {
    width: 16px;
    text-align: center;
}

.cost-value {
    font-weight: 600;
    color: #28a745;
    font-size: 0.95rem;
}

/* Action Buttons Grid */
.action-buttons-grid {
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.875rem;
}

.sidebar-action-btn {
    width: 100%;
    justify-content: flex-start;
    padding: 0.875rem 1.25rem;
    border-radius: 8px;
    transition: all 0.3s ease;
    font-weight: 500;
    font-size: 0.9rem;
    border-width: 1.5px;
}

.sidebar-action-btn:hover {
    transform: translateX(5px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.sidebar-action-btn[severity="primary"] {
    background: linear-gradient(135deg, #4361ee 0%, #667eea 100%);
    border-color: #4361ee;
}

.sidebar-action-btn[severity="success"] {
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    border-color: #28a745;
}

.sidebar-action-btn[severity="secondary"][outlined] {
    border-color: #6c757d;
    color: #6c757d;
}

.sidebar-action-btn[severity="secondary"][outlined]:hover {
    background-color: #6c757d;
    color: white;
}

.sidebar-action-btn[severity="info"][outlined] {
    border-color: #17a2b8;
    color: #17a2b8;
}

.sidebar-action-btn[severity="info"][outlined]:hover {
    background-color: #17a2b8;
    color: white;
}

.sidebar-action-btn[severity="warning"][outlined] {
    border-color: #ffc107;
    color: #856404;
}

.sidebar-action-btn[severity="warning"][outlined]:hover {
    background-color: #ffc107;
    color: #856404;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
    .maintenance-dialog :deep(.p-dialog) {
        width: 95vw !important;
        margin: 1rem;
    }

    .dialog-content {
        padding: 1rem;
    }

    .maintenance-footer {
        justify-content: center;
    }

    .footer-btn {
        min-width: 100px;
        font-size: 0.9rem;
    }

    .asset-details-sidebar {
        width: 100% !important;
    }
}

/* Animation Classes */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.dialog-content>* {
    animation: fadeInUp 0.3s ease forwards;
}

.sidebar-card {
    animation: fadeInUp 0.4s ease forwards;
}
</style>
